// extracted by mini-css-extract-plugin
export default {"section":"FormSection_section__drTOk","label":"FormSection_label__d-Tq1"};